module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO ID_DESTAQUES-a0b3f7f18455eaa602716841f3e70858.png";